import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ConversationList = ({ conversations, activeConversation, onSelectConversation, userRole }) => {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / 60000);

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return date?.toLocaleDateString();
  };

  const getDisplayName = (conversation) => {
    if (userRole === 'customer') {
      return conversation?.otherParty?.business_name || conversation?.otherParty?.user?.full_name || 'Supplier';
    }
    return conversation?.otherParty?.user?.full_name || 'Customer';
  };

  const getAvatarUrl = (conversation) => {
    return conversation?.otherParty?.user?.avatar_url || 'https://randomuser.me/api/portraits/lego/1.jpg';
  };

  if (conversations?.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center">
          <Icon name="MessageSquare" size={48} className="mx-auto mb-3 text-muted-foreground" />
          <p className="text-muted-foreground text-sm">No conversations yet</p>
          <p className="text-muted-foreground text-xs mt-1">
            {userRole === 'customer' ? 'Start chatting with suppliers' : 'Customers will reach out to you'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {conversations?.map((conversation) => (
        <div
          key={conversation?.id}
          onClick={() => onSelectConversation(conversation)}
          className={`p-4 border-b border-border cursor-pointer transition-smooth hover:bg-muted ${
            activeConversation?.id === conversation?.id ? 'bg-muted' : ''
          }`}
        >
          <div className="flex items-start gap-3">
            <div className="relative flex-shrink-0">
              <Image
                src={getAvatarUrl(conversation)}
                alt={`${getDisplayName(conversation)} profile picture`}
                className="w-12 h-12 rounded-full object-cover"
              />
              {conversation?.unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-accent text-accent-foreground text-xs font-bold rounded-full flex items-center justify-center">
                  {conversation?.unreadCount > 9 ? '9+' : conversation?.unreadCount}
                </span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-1">
                <h4 className="font-heading font-semibold text-sm text-foreground truncate">
                  {getDisplayName(conversation)}
                </h4>
                <span className="text-xs text-muted-foreground flex-shrink-0">
                  {formatTime(conversation?.lastMessageTime)}
                </span>
              </div>
              <div className="flex items-center gap-2">
                {conversation?.lastMessageType === 'image' && (
                  <Icon name="Image" size={14} className="text-muted-foreground flex-shrink-0" />
                )}
                <p className="text-sm text-muted-foreground line-clamp-1">
                  {conversation?.lastMessage}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationList;